import Vue from 'vue'
import Router from 'vue-router'
//信用
import creditRtr from './path/credit'
//科技赋能
import scienceRtr from './path/science'
//关于我们
import aboutRtr from './path/about'
//网站合作
import cooperationRtr from './path/cooperation'
//管理团队
import teamnRtr from './path/team'



//首页
const index = resolve => require(['@/page/index/index'], resolve);
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: "北京京融科技有限责任公司" //赢链通官网
      }
    }
  ].concat(
    creditRtr,
    scienceRtr,
		aboutRtr,
    cooperationRtr,
    teamnRtr
  )
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "";
  next();
  window.scrollTo(0,0);
});

export default router
